import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { byDesign } from '@/infra/design'
import imgRemoveCollaboratorUrl from '@/assets/misc/img_remove-collaborator.svg'
import DocumentsDisabledIllustration from '@/components/SpotIllustration/DocumentsDisabledIllustration'

export function OCRScopeJobErrorOccurred() {
  return (
    <EmptyState size="sm">
      <EmptyStateIllustration
        src={imgRemoveCollaboratorUrl}
        illustration={byDesign(undefined, DocumentsDisabledIllustration)}
      />
      <EmptyStateTitle>OCR scoping failed</EmptyStateTitle>
      <EmptyStateDescription>
        There was an issue with the uploaded files, so our team will create this
        job on your behalf. When ready, the job will be visible on the job
        management table.
      </EmptyStateDescription>
    </EmptyState>
  )
}
